import React, { useRef, useState } from "react";
import { H2, H3, Text } from "@shoptet/ui";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AdPreview from "../../assets/meta-ad-preview.png";
import { WIZARD_STEP_PATH } from "../../constants/paths";
import { MetaPrimaryText, MetaPrimaryTextHandle } from "../../elements/MetaWizard/MetaPrimaryText";
import MetaWizardFooter from "../../elements/MetaWizard/MetaWizardFooter";
import MetaWizardHeader from "../../elements/MetaWizard/MetaWizardHeader";
import WizardHeader from "../../elements/WizardHeader";
import { AdSystemT, WizardStepT } from "../../graphql/generated/graphql";
import { useSetWizardStepEffect } from "./useSetWizardStepEffect";

export const MetaAdtext = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Wizard Meta Adtext" });
  const navigate = useNavigate();
  const metaPrimaryTextRef = useRef<MetaPrimaryTextHandle>(null);
  const [isNextDisabled, setIsNextDisabled] = useState(true);

  const backButtonHandler = () => {
    navigate(WIZARD_STEP_PATH.META_PRODUCTS_SELECTION);
  };

  const nextButtonHandler = async () => {
    if (metaPrimaryTextRef.current) {
      await metaPrimaryTextRef.current.save();
    }
    navigate(WIZARD_STEP_PATH.META_BUDGET);
  };

  // Check validity whenever component might re-render
  React.useEffect(() => {
    const checkValidity = () => {
      if (metaPrimaryTextRef.current) {
        setIsNextDisabled(!metaPrimaryTextRef.current.isValid() || metaPrimaryTextRef.current.isSaving());
      }
    };

    const interval = setInterval(checkValidity, 100);
    return () => clearInterval(interval);
  }, []);

  useSetWizardStepEffect({ adSystem: AdSystemT.MetaAdsT, wizardStep: WizardStepT.MetaTextSelectionT });
  return (
    <div>
      <WizardHeader />
      <MetaWizardHeader activeStep={4} />
      <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>
        <div className="meta-adtext-container-1">
          <div style={{ marginBottom: "24px" }}>
            <H2>{t("Heading")}</H2>
          </div>
          <MetaPrimaryText ref={metaPrimaryTextRef} />
        </div>
        <div className="meta-adtext-container-2">
          <H3 appearance="strong-lg">{t("Block 2 title")}</H3>
          <Text>{t("Block 2 list title")}</Text>
          <ul style={{ margin: "0 0 16px", paddingLeft: "15px" }}>
            <li>
              <Trans components={{ b: <b /> }} i18nKey="Block 2 list item 1" t={t} />
            </li>
            <li>
              <Trans components={{ b: <b /> }} i18nKey="Block 2 list item 2" t={t} />
            </li>
          </ul>
          <img alt="" src={AdPreview} style={{ borderRadius: "var(--app-radius-box)" }} />
        </div>
      </div>
      <MetaWizardFooter
        backButtonHandler={backButtonHandler}
        nextButtonDisabled={isNextDisabled}
        nextButtonHandler={nextButtonHandler}
      />
    </div>
  );
};
